/* eslint-disable max-len */
import React, { useEffect, useState } from "react";

import { Field } from "formik";

import {
  MultiselectContainer,
  CheckboxLabel,
  CheckboxInput,
  CheckboxWrapper,
  StyledCheckbox,
  Container,
  Wrapper,
} from "./styles";

import IField from "../../../../interfaces/field";
import TplGroup from "../tpl-group";

interface IOption {
  label: string;
  value: string | number;
  subOptions?: string[];
}

type IAnyField = any & IField;

interface IProps extends Omit<IAnyField, "options"> {
  options: IOption[];
  onSelect: any;
  onChange?: any;
  initialSelectedOptions?: (string | number)[];
}

const Multiselect: React.FC<IProps> = ({
  options,
  onSelect,
  title,
  required = false,
  name,
  prefixName = "",
  onChange,
  initialSelectedOptions = [],
  ...el
}) => {
  const [selectedOptions, setSelectedOptions] = useState<(string | number)[]>(
    initialSelectedOptions);

  useEffect(() => {
    setSelectedOptions(initialSelectedOptions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(initialSelectedOptions)]);

  useEffect(() => {
    if (el.setFieldValue) {
      el.setFieldValue(`${prefixName}${name}`, selectedOptions);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOptions]);

  const handleOptionClick = (value: string | number): void => {
    if (onSelect) {
      onSelect(value);
    }

    const isSelected = selectedOptions.includes(value);
    const updatedSelectedOptions = isSelected
      ? selectedOptions.filter((option) => option !== value)
      : [...selectedOptions, value];

    setSelectedOptions(updatedSelectedOptions);

    if (onChange) {
      onChange(updatedSelectedOptions);
    }

    if (el.setFieldValue) {
      el.setFieldValue(`${prefixName}${name}`, updatedSelectedOptions);
    }
  };

  return (
    <Wrapper>
      <TplGroup
        name={`${prefixName}${name}`}
        title={title}
        prefixName={prefixName}
        required={required}
        onChange={onChange}
        {...el}
      >
        <Container>
          {options.map((option) => (
            <MultiselectContainer key={option.label}>
              <CheckboxWrapper>
                <Field
                  type="checkbox"
                  value={option.value}
                  as={StyledCheckbox}
                  checked={selectedOptions.includes(option.value)}
                  onClick={() => handleOptionClick(option.value)}
                  disabled={el?.disabled === true}
                />
                <CheckboxLabel onClick={() => handleOptionClick(option.value)}>
                  {option.label}
                </CheckboxLabel>
              </CheckboxWrapper>

              {selectedOptions.includes(option.label) && option.subOptions && (
                <div style={{ marginLeft: "30px" }}>
                  {option.subOptions.map((subOption) => (
                    <CheckboxWrapper key={subOption}>
                      <CheckboxInput
                        type="checkbox"
                        checked={selectedOptions.includes(subOption)}
                        onChange={() => handleOptionClick(subOption)}
                      />
                      <StyledCheckbox
                        isChecked={selectedOptions.includes(subOption)}
                      />
                      <CheckboxLabel
                        onClick={() => handleOptionClick(subOption)}
                      >
                        {subOption}
                      </CheckboxLabel>
                    </CheckboxWrapper>
                  ))}
                </div>
              )}
            </MultiselectContainer>
          ))}
        </Container>
      </TplGroup>
    </Wrapper>
  );
};

export default Multiselect;
